module.exports = __webpack_public_path__ + "img/logo.28243440.svg";